import type { IconData } from '@stacksjs/iconify-core'

export const computersDevicesElectronicsFlashDrive2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10.665 7.62V1.53h-1.52v6.09h-1.53v21.34h1.53V9.15h13.71v19.81h1.53V7.62h-1.53V1.53h-1.52v6.09zm10.67 21.34h1.52v1.52h-1.52Z\"/><path fill=\"currentColor\" d=\"M19.805 15.24h1.53v3.05h-1.53Zm-9.14 15.24h10.67V32h-10.67Zm7.62-12.19h1.52v1.52h-1.52Z\"/><path fill=\"currentColor\" d=\"M16.765 10.67h-1.53v9.14h-1.52v4.57h4.57v-4.57h-1.52zm-4.57-7.62h7.61v1.52h-7.61Zm0 15.24h1.52v1.52h-1.52ZM10.665 0h10.67v1.53h-10.67Zm0 13.72h1.53v4.57h-1.53Zm-1.52 15.24h1.52v1.52h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default computersDevicesElectronicsFlashDrive2
